export const buttonVariants = ['destructive', 'ghost', 'primary', 'secondary', 'tertiary'] as const;
export type ButtonVariant = (typeof buttonVariants)[number];

export const iconButtonVariants = ['destructive', 'ghost', 'primary', 'secondary', 'tertiary'] as const;
export type IconButtonVariant = (typeof iconButtonVariants)[number];

export const splitButtonVariants = ['primary', 'secondary', 'tertiary'] as const;
export type SplitButtonVariant = (typeof splitButtonVariants)[number];

export const dropDownButtonVariants = ['primary', 'secondary', 'tertiary', 'ghost'] as const;
export type DropDownButtonVariant = (typeof dropDownButtonVariants)[number];

export type AccordionVariant = 'secondary';

export type AlertIconVariant = 'info' | 'success' | 'warning' | 'error';

export type BannerVariant = 'info' | 'success' | 'warning' | 'error';

export type CalendarFooterVariant = 'default' | 'secondary';

export type CalendarSelectorVariant = 'ghost' | 'selected' | 'inRange' | 'disabled' | 'today';

export type CardContentVariant = 'default' | 'highlighted';

export type TypographyVariant = 'secondary' | 'inverse';

/** @deprecated */
export type BaseLayoutVariants = 'breakpointLargeUp' | 'small' | 'large';

/** @deprecated */
export type LayoutCellVariants =
    | 'breakpointExtraSmallUp'
    | 'breakpointSmallUp'
    | 'breakpointMediumUp'
    | 'breakpointLargeUp'
    | 'breakpointExtraLargeUp';

export type IconVariant = 'basic' | 'primary' | 'info' | 'success' | 'warning' | 'danger' | 'inverse';

export type LegendCircleVariant = 'basic' | 'primary' | 'success';

export type NestedCardVariant = 'default' | 'emphasized' | 'highlighted';

export type MessageAuthor = 'user' | 'team' | 'other';

export type MewsLogoVariant = 'default' | 'inverse';

export type NotificationVariant = 'basic' | 'primary' | 'info' | 'success' | 'warning' | 'danger';

export type SystemWideBannerVariant = 'info' | 'warning' | 'danger';

export type ListItemVariant = 'default' | 'error';
